import { useEffect, useState } from 'react';
import ZoomIcon from "../../Images/zoom.png";
import WebexIcon from "../../Images/webex.png";
import MicrosoftIcon from "../../Images/microsoft.png";
import AppDownload from "../../Components/AppDownload/AppDownload";
import SubTitle from "../../Components/SubTitle/SubTitle";
import DashboardHeader from "../../Components/DashboardHeader/DashboardHeader";
import IntegrationPromoCode from '../../Components/IntegrationPromoCode/IntegrationPromoCode';
import { useClientUserState } from '../../Contexts/ClientUserStateContext';
import { useGlobalState } from '../../Contexts/GlobalStateContext';
import { useApi } from '../../Services/api';
import "./Integrations.css";

const Integrations = () => {
  const [loaded, setLoaded] = useState(false);
  const { clientUser } = useClientUserState();
  const { setErrorVisible, setErrorMessage } = useGlobalState();
  const [promoCode, setPromoCode] = useState('');
  const api = useApi();

  useEffect(() => {
    const fetchUserPromoCode = async () => {
      try {
        const response = await api.get('Client/GetIntegrationPromoCode');
        const data = response.data;
        const promoCode = data.PromoCode;
        setLoaded(true);
        if (promoCode.Error) {
          setErrorVisible(true);
          setErrorMessage(promoCode.Error);
          return;
        }
        setPromoCode(promoCode);
      } catch (error) {
        console.log('error:', error);
      }
    };
    fetchUserPromoCode();
  }, []);
  
  if (!loaded) return null;
  return (
    <div className="integra-container">
      <DashboardHeader title="Integrations" />
      <div className="sub-text">
        <SubTitle subTitle="Video Conferencing Integrations" />
        <p>
          Instantly bring an interpreter into a video conferencing call by following the admin guide and applying the promo code. 
          After setup, refer to the user guide to launch Voyce within the platform.
        </p>
      </div>
      <div className="app-part">
        <AppDownload
          className="left"
          image={ZoomIcon}
          title="Zoom Integration"
          pdfFiles={[
            { pdfName: 'ZoomPdf', displayName: 'User Guide' },
            { pdfName: 'ZoomAdminPdf', displayName: 'Admin Guide' }
          ]}
        />
        <AppDownload
          className="right"
          image={WebexIcon}
          title="Webex Integration"
          pdfFiles={[
            { pdfName: 'WebexUserPdf', displayName: 'User Guide' },
            { pdfName: 'WebexAdminPdf', displayName: 'Admin Guide' }
          ]}
        />
        <AppDownload
          className="left"
          image={MicrosoftIcon}
          title="Microsoft Teams Integration"
          pdfFiles={[
            { pdfName: 'MicrosoftUserPdf', displayName: 'User Guide' },
            { pdfName: 'MicrosoftAdminPdf', displayName: 'Admin Guide' }
          ]}
        />
      </div>
      {(clientUser.IsAdmin && promoCode) && 
      <IntegrationPromoCode promoCode={promoCode}/>}
      <div className="integra-learn-wrapper">
        <div className="integra-learn">
          To learn more about Voyce's EHR and Telehealth integrations, visit&nbsp;
          <a className="integra-link underline" href="https://web.voyceglobal.com/integrations">https://web.voyceglobal.com/integrations</a>
        </div>
      </div> 
    </div>
  );
};

export default Integrations;
